import { CircleCheck, PlusIcon, UsersIcon } from 'lucide-react'

import { useOnboarding } from 'components/member_onboarding_v2/OnboardingContext'
import { Button, Checkbox, Tooltip } from 'slab'

import { MAX_PROVIDERS_TO_VERIFY, useProviderInNetworkVerificationContext } from '../ProviderInNetworkVerificationContext/ProviderInNetworkVerificationContext'

export const InNetworkProviderCard: React.FC<{
  disabled?: boolean
  openProviderSearchModal?: () => void
}> = ({ disabled, openProviderSearchModal }) => {
  const { selectedProviderNpis, canAddMoreProviders, inNetworkProviders, onToggleSelectedProvider, verifyingInNetworkStatusProviderNpis } = useProviderInNetworkVerificationContext()
  const { onboardingData } = useOnboarding()
  const providers = onboardingData?.provider_preferences
  return (
    <div className='border rounded-lg border-gray-400 bg-white overflow-hidden'>
      <div className='flex flex-col p-4'>
        <div className='flex items-center justify-between'>
          <div className='flex gap-1 mb-1 items-center'>
            <UsersIcon className='text-gray-400' size={14} />
            <span className='body-bold'>Providers</span>
          </div>
          {openProviderSearchModal && (
            <Button onClick={openProviderSearchModal} variant='tertiary' leftIcon={PlusIcon}>
              Add provider
            </Button>
          )}
        </div>
        {!disabled && <span className='body-sm text-gray-500 mb-3'>We can check up to {MAX_PROVIDERS_TO_VERIFY} providers for you</span>}
        <div data-testid='providers' className='flex flex-col gap-2'>
          {
            providers?.map((provider) => {
              const isVerifying = verifyingInNetworkStatusProviderNpis.length ? verifyingInNetworkStatusProviderNpis.includes(provider.npi) : false
              if (inNetworkProviders.find(p => p.npi === provider.npi) && !isVerifying) return null
              if (verifyingInNetworkStatusProviderNpis.length && !isVerifying) return null
              const name = [provider.first_name, provider.last_name].join(' ')
              const disabledCheckbox = !canAddMoreProviders && !selectedProviderNpis.includes(provider.npi)
              return (
                <div className='p-3 border rounded-lg' key={provider.npi}>
                  {
                    disabled
                      ? name
                      : (
                        <Tooltip enabled={disabledCheckbox} content={`A maximum of ${MAX_PROVIDERS_TO_VERIFY} providers can be selected`}>
                          <div className='w-fit'>
                            <Checkbox
                              disabled={disabledCheckbox}
                              onChange={e => onToggleSelectedProvider(provider.npi, e.target.checked)}
                              label={name}
                              checked={selectedProviderNpis.includes(provider.npi)}
                            />
                          </div>
                        </Tooltip>
                        )
                  }
                </div>
              )
            })
          }
        </div>
      </div>
      {
        inNetworkProviders.length > 0 && (
          <div data-testid='in-network' className='p-4 bg-gray-50 border-t border-gray-200 flex flex-col gap-3'>
            <div className='body-sm text-gray-500'>These providers are in-network with all of your selected plans:</div>
            {
              inNetworkProviders.map((provider) => {
                const name = [provider.first_name, provider.last_name].join(' ')
                return (
                  <div className='flex gap-1' key={provider.npi}>
                    <CircleCheck size={16} className='text-green-400' />
                    <span className='body-sm'>{name}</span>
                  </div>
                )
              })
            }
          </div>
        )
      }
    </div>
  )
}
